import { useRef, useState, useEffect, useCallback } from 'react'

const useAccordionItem = (isOpen: boolean) => {
  const accRef = useRef<HTMLInputElement>(null)
  const headAccRef = useRef<HTMLInputElement>(null)

  const [useAccordionHeight, setAccordionHeight] = useState<number>(0)
  const [useAccordionHeaderHeight, setAccordionHeaderHeight] = useState(0)
  const [isVisible, setVisible] = useState(false)

  const handleChange = useCallback(() => {
    const { height } = headAccRef.current.getBoundingClientRect()

    if (isOpen) {
      setAccordionHeaderHeight(height)
      setAccordionHeight(window.innerHeight)
      setTimeout(() => {
        setVisible(true)
      }, 100)
    } else {
      setVisible(false)
      setAccordionHeaderHeight(0)
      setAccordionHeight(0)
    }
  }, [isOpen])

  useEffect(() => {
    handleChange()
  }, [isOpen, handleChange])

  return {
    isVisible,
    useAccordionHeaderHeight,
    useAccordionHeight,
    accRef,
    headAccRef,
  }
}

export default useAccordionItem
